import {requestRemoteData} from "../../../API/api";

const RELATED_PRODUCTS_ENDPOINT = 'products/related';
const CATALOG_ENDPOINT = 'products';
const FAVORITES_ENDPOINT = 'account/favorites';
const TRACKED_PRODUCTS_ENDPOINT = 'account/products/tracked';

export const fetchRelatedProducts = (productCode, { page, amount }, actingAsNumCliente = null) => {
  const headers = {'X-Api-Version': '2'};
  if (actingAsNumCliente) headers['X-Acting-As-Client'] = actingAsNumCliente;
  return requestRemoteData(
    RELATED_PRODUCTS_ENDPOINT,
    {
        method: 'POST',
        body: {
            productCode: productCode,
            pagination: {
                page: page,
                size: amount
            }
        },
        headers
    }
  );
};

export const fetchAllBis = (filters, config, actingAsNumCliente = null) => {
    const headers = {};
    if (actingAsNumCliente) headers['X-Acting-As-Client'] = actingAsNumCliente;
    return requestRemoteData(
        CATALOG_ENDPOINT,
        {
            method: 'POST',
            headers,
            body: {
                filter: {
                    taxonomy: {
                        macrofamilyIds: filters?.taxonomyTree?.macrofamilyId ? [filters.taxonomyTree?.macrofamilyId] : null,
                        familyIds: filters?.taxonomyTree?.familyId ? [filters?.taxonomyTree?.familyId] : null,
                        subfamilyIds: filters?.taxonomyTree?.subfamilyIds ? Array.from(filters?.taxonomyTree?.subfamilyIds) : null,
                    },
                    search: filters?.search,
                    species: filters?.species ? Array.from(filters.species) : null,
                    manufacturerIds: filters?.manufacturerIds ? Array.from(filters?.manufacturerIds) : null,
                    characteristics: {
                        featured: filters?.characteristics?.featured,
                        prescription: filters?.characteristics?.prescription
                    }
                },
                pagination: {
                    page: config.page,
                    size: config.amount
                }
            }
        }
    );
};

export const fetchFavorites = (actingAsNumCliente = null) => {
  const headers = { 'X-Api-Version': '2' };
  if (actingAsNumCliente) headers['X-Acting-As-Client'] = actingAsNumCliente;
  return requestRemoteData(FAVORITES_ENDPOINT, { headers });
};

export const fetchTracked = (actingAsNumCliente = null) => {
  const headers = {};
  if (actingAsNumCliente) headers['X-Acting-As-Client'] = actingAsNumCliente;
  return requestRemoteData(TRACKED_PRODUCTS_ENDPOINT, { headers });
};
